import GDKError from './GDKError';
export default class GDKFormError extends GDKError {
    originalColumns;
    columns;
    constructor(original, lang, code, columns, response = null) {
        super(original, lang, code, response);
        this.name = 'GDKFormError';
        this.originalColumns = columns;
        this.columns = {};
    }
}
//# sourceMappingURL=GDKFormError.js.map